var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":("/categories/" + (_vm.category.id))}},[_vm._v(" "+_vm._s(_vm.translation)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }